import { useDisclosure } from "@chakra-ui/hooks";
import { Modal, ModalOverlay } from "@chakra-ui/modal";
import React, { useContext } from "react";
import { BsInfoCircleFill } from "react-icons/bs";
import { MdCheck, MdFileCopy, MdHighlightOff, MdInfoOutline } from "react-icons/md";
import { ClientContext } from "ClientProvider";
import { Popover, PopoverTrigger, PopoverContent, PopoverHeader, PopoverArrow } from "@chakra-ui/react";

/* Used in PayoutList (batch) — shows raw gateway response only */
const InfoModal = ({ info, varient }: { info?: any; varient?: string }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [copied, setCopied] = React.useState(false);
  const [isCloseModal, setIsCloseModal] = React.useState(false);
  const { singleRoleData } = useContext(ClientContext);
  const [popoverOpen, setPopoverOpen] = React.useState(false);

  let parsed: any = {};
  try {
    if (info) {
      if (typeof info === "string") {
        parsed = JSON.parse(
          info.replace(/\bNone\b/g,"null").replace(/\bFalse\b/g,"false").replace(/\bTrue\b/g,"true")
            .replace(/([{,]\s*)'([^']+)'\s*:/g,'$1"$2":').replace(/:\s*'([^']*)'/g,': "$1"')
        );
      } else { parsed = info; }
    }
  } catch { parsed = {}; }

  const handleClose = () => {
    setIsCloseModal(true);
    setTimeout(() => { setIsCloseModal(false); onClose(); }, 300);
  };
  const copy = () => {
    navigator.clipboard.writeText(JSON.stringify(parsed, null, 2));
    setCopied(true); setTimeout(() => setCopied(false), 1500);
  };

  return (
    <>
      {singleRoleData?.[0]?.crypto?.value?.view_crypto_payout_response_information && (
        <Popover trigger="hover" placement="bottom" closeOnBlur  closeOnEsc isOpen={popoverOpen && !isOpen} onOpen={() => setPopoverOpen(true)} onClose={() => setPopoverOpen(false)}>
          <PopoverTrigger>
            <button className="cp-info-trigger" onClick={onOpen} aria-label="View crypto payout info" onMouseEnter={() => !isOpen && setPopoverOpen(true)} onMouseLeave={() => setPopoverOpen(false)}>
              <MdInfoOutline size={14} />
            </button>
          </PopoverTrigger>
          <PopoverContent border="1px solid #ddd6fe" borderRadius="12px" bg="#faf5ff" maxW="220px" p="0" overflow="hidden" zIndex="20">
            <PopoverHeader bg="#ede9fe" fontSize="12px" fontWeight="700" color="#6d28d9" borderBottom="1px solid #ddd6fe" px="14px" py="10px">
              View Payout Info
            </PopoverHeader>
            <PopoverArrow bg="#faf5ff" />
          </PopoverContent>
        </Popover>
      )}

      <Modal isOpen={isOpen} onClose={() => {}}>
        <ModalOverlay bg="rgba(15,23,42,0.55)" backdropFilter="blur(4px)" />
        <div className={`cp-panel${isOpen && !isCloseModal ? " cp-panel--open" : " cp-panel--close"}`}>
          <div className="cp-panel-glow" />

          <div className="cp-panel-header">
            <div className="cp-panel-brand">
              <div className="cp-panel-logo">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/>
                </svg>
              </div>
              <div>
                <h2 className="cp-panel-title">Gateway Response</h2>
                <p className="cp-panel-sub">Raw crypto gateway response data</p>
              </div>
            </div>
            <button className="cp-panel-close" onClick={handleClose}><MdHighlightOff size={22} /></button>
          </div>

          <div className="cp-panel-body">
            {parsed && Object.keys(parsed).length > 0 ? (
              <div className="cp-json-section">
                <div className="cp-json-header">
                  <div className="cp-json-label">
                    <div className="cp-json-dot cp-json-dot--purple" />
                    Gateway Response
                  </div>
                  <button className={`cp-copy-btn${copied ? " cp-copy-btn--copied" : ""}`} onClick={copy}>
                    {copied ? <><MdCheck size={13} />Copied!</> : <><MdFileCopy size={13} />Copy</>}
                  </button>
                </div>
                <div className="cp-json-wrap">
                  <pre className="cp-json-pre">{JSON.stringify(parsed, null, 2)}</pre>
                </div>
              </div>
            ) : (
              <div className="cp-empty">
                <div className="cp-empty-icon">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"/>
                  </svg>
                </div>
                <p className="cp-empty-title">No gateway response</p>
                <p className="cp-empty-desc">No response data available for this transaction.</p>
              </div>
            )}
          </div>

          <div className="cp-panel-footer">
            <div className="cp-footer-note">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              Read-only payout response data
            </div>
            <button className="cp-btn-close" onClick={handleClose}>Close</button>
          </div>
        </div>
      </Modal>

      {CP_PANEL_STYLES}
    </>
  );
};

export default InfoModal;

/* ── Shared crypto panel styles ── */
export const CP_PANEL_STYLES = (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

    
    .cp-info-trigger {
      width: 28px; height: 28px; border-radius: 7px; background: #f8fafc;
      border: 1.5px solid #e2e8f0; color: #64748b;
      display: flex; align-items: center; justify-content: center;
      transition: all .15s; cursor: pointer;
    }
    .cp-info-trigger:hover { background: #eff6ff; border-color: #bfdbfe; color: #2563eb; }
    .cp-info-trigger:disabled { opacity: .45; cursor: not-allowed; }

    .cp-panel { font-family:'Plus Jakarta Sans',sans-serif; position:fixed; top:0; right:0; bottom:0; width:100%; max-width:640px; background:#fff; z-index:1004; display:flex; flex-direction:column; box-shadow:-12px 0 60px rgba(15,23,42,.18); transition:transform .35s cubic-bezier(0.16,1,0.3,1); overflow:hidden; }
    .cp-panel--open  { transform:translateX(0); }
    .cp-panel--close { transform:translateX(100%); }

    .cp-panel-glow { height:3px; flex-shrink:0; background:linear-gradient(90deg,#3b0764,#7c3aed,#a855f7,#7c3aed,#3b0764); background-size:200% 100%; animation:cpGlow 3s linear infinite; }
    @keyframes cpGlow { 0%{background-position:0%} 100%{background-position:200%} }

    .cp-panel-header { padding:15px 26px; background:linear-gradient(135deg,#3b0764 0%,#6d28d9 60%,#7c3aed 100%); display:flex; align-items:center; justify-content:space-between; flex-shrink:0; }
    .cp-panel-brand { display:flex; align-items:center; gap:13px; }
    .cp-panel-logo { width:42px; height:42px; border-radius:12px; background:rgba(255,255,255,.15); border:1.5px solid rgba(255,255,255,.25); display:flex; align-items:center; justify-content:center; flex-shrink:0; }
    .cp-panel-title { font-size:16px; font-weight:800; color:#fff; letter-spacing:-.3px; margin-bottom:2px; line-height:1; }
    .cp-panel-sub { font-size:12px; color:rgba(255,255,255,.55); font-weight:500; }
    .cp-panel-close { background:none; border:none; cursor:pointer; color:rgba(255,255,255,.65); display:flex; align-items:center; transition:color .15s; }
    .cp-panel-close:hover { color:#fff; }

    .cp-panel-body { flex:1; overflow-y:auto; background:#f8fafc; padding:20px 24px; display:flex; flex-direction:column; gap:16px; }
    .cp-panel-body::-webkit-scrollbar { width:4px; }
    .cp-panel-body::-webkit-scrollbar-thumb { background:#cbd5e1; border-radius:4px; }

    /* Tab bar */
    .cp-tab-bar { display:flex; border-bottom:1.5px solid #e2e8f0; background:#fafbfc; flex-shrink:0; padding:0 24px; }
    .cp-tab { display:inline-flex; align-items:center; gap:7px; font-family:'Plus Jakarta Sans',sans-serif; font-size:13px; font-weight:600; color:#64748b; padding:14px 16px; border:none; background:none; border-bottom:2.5px solid transparent; cursor:pointer; transition:all .18s; margin-bottom:-1.5px; }
    .cp-tab:hover { color:#7c3aed; }
    .cp-tab--active { color:#7c3aed; border-bottom-color:#7c3aed; font-weight:700; }

    /* JSON block */
    .cp-json-section { background:#fff; border:1px solid #e2e8f0; border-radius:14px; overflow:hidden; }
    .cp-json-header { display:flex; align-items:center; justify-content:space-between; padding:12px 16px; background:#f8fafc; border-bottom:1px solid #f1f5f9; }
    .cp-json-label { display:flex; align-items:center; gap:8px; font-size:12px; font-weight:700; color:#374151; text-transform:uppercase; letter-spacing:.4px; }
    .cp-json-dot { width:8px; height:8px; border-radius:50%; flex-shrink:0; }
    .cp-json-dot--blue   { background:#2563eb; box-shadow:0 0 0 3px rgba(37,99,235,.15); }
    .cp-json-dot--green  { background:#16a34a; box-shadow:0 0 0 3px rgba(22,163,74,.15); }
    .cp-json-dot--purple { background:#7c3aed; box-shadow:0 0 0 3px rgba(124,58,237,.15); }
    .cp-copy-btn { display:inline-flex; align-items:center; gap:5px; font-family:'Plus Jakarta Sans',sans-serif; font-size:12px; font-weight:600; color:#64748b; padding:5px 12px; border-radius:7px; border:1.5px solid #e2e8f0; background:#fff; cursor:pointer; transition:all .15s; }
    .cp-copy-btn:hover { background:#f1f5f9; }
    .cp-copy-btn--copied { color:#15803d; border-color:#bbf7d0; background:#f0fdf4; }
    .cp-json-wrap { overflow:auto; max-height:500px; }
    .cp-json-wrap::-webkit-scrollbar { width:4px; height:4px; }
    .cp-json-wrap::-webkit-scrollbar-thumb { background:#cbd5e1; border-radius:4px; }
    .cp-json-pre { margin:0; padding:16px 18px; font-family:'JetBrains Mono','Courier New',monospace; font-size:12.5px; line-height:1.65; color:#1e293b; white-space:pre; background:#fff; }

    .cp-empty { display:flex; flex-direction:column; align-items:center; justify-content:center; padding:48px 24px; gap:10px; }
    .cp-empty-icon { width:48px; height:48px; border-radius:12px; background:#f8fafc; border:1.5px solid #e2e8f0; display:flex; align-items:center; justify-content:center; color:#cbd5e1; }
    .cp-empty-title { font-size:13.5px; font-weight:700; color:#64748b; }
    .cp-empty-desc { font-size:12px; color:#94a3b8; font-weight:500; text-align:center; }

    .cp-panel-footer { padding:14px 26px; border-top:1.5px solid #f1f5f9; background:#fafbfc; display:flex; align-items:center; justify-content:space-between; flex-shrink:0; }
    .cp-footer-note { display:flex; align-items:center; gap:6px; font-size:12px; color:#94a3b8; font-weight:500; }
    .cp-btn-close { font-family:'Plus Jakarta Sans',sans-serif; font-size:13.5px; font-weight:600; color:#64748b; padding:10px 24px; border-radius:10px; border:1.5px solid #e2e8f0; background:#fff; cursor:pointer; transition:all .15s; }
    .cp-btn-close:hover { background:#f1f5f9; }

    @media (max-width:520px) { .cp-panel { max-width:100%; } .cp-panel-header { padding:16px 18px; } .cp-panel-body { padding:16px; } }
  `}</style>
);